function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_67422",
  "data-name": "Group 67422",
  transform: "translate(-25 -2638)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  "data-name": "Path 71",
  d: "M30,2654a3,3,0,1,1-3,3A3,3,0,0,1,30,2654Zm0,2a1,1,0,1,1-1,1A1,1,0,0,1,30,2656Z",
  fill: "#7e84a3",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  "data-name": "Path 72",
  d: "M26,2643a4,4,0,0,1,8,0c0,5-4,5-4,8",
  fill: "none",
  stroke: "#869ea6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}));

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 22,
    viewBox: "0 0 10 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.68200e1c.svg";
export { ForwardRef as ReactComponent };